import styles from "../moveout-checklist.module.css";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { useAuth0 } from "@auth0/auth0-react";
import { useState, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer"; // make sure this import is correct
import { X } from "react-feather";

const FormFooter = ({ onSubmitSignatureCommentsData, moveOutCheckListInfo, setLoading }) => {
  const { getAccessTokenSilently } = useAuth0();

  // Signature state
  const [managerSignature, setManagerSignature] = useState({});
  const [tenant1Signature, setTenant1Signature] = useState({});
  const [tenant2Signature, setTenant2Signature] = useState({});
  const [tenant3Signature, setTenant3Signature] = useState({});
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [currentSigner, setCurrentSigner] = useState(null);
  const signaturePadRef = useRef();

  function formatDateUS(dateString) {
    const date = new Date(dateString);
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  const submitSignature = async (base64Data, name) => {
    const file = base64Data;

    setLoading(true);
    try {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      const formData = new FormData();
      formData.append("image", file);

      const response = await axios.post(process.env.REACT_APP_PAYMENT_API_URL + `v1/save-sign-image-move-out`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        }
      });

      const { file_path, file_url } = response.data.data;
      signaturePadRef.current.clear();

      const updateStateAndSubmit = (setFn, key) => {
        setFn({ file_path, file_url });
        onSubmitSignatureCommentsData(key, file_path);
      };

      switch (name) {
        case "tenant1":
          updateStateAndSubmit(setTenant1Signature, "tenant1_sign");
          break;
        case "tenant2":
          updateStateAndSubmit(setTenant2Signature, "tenant2_sign");
          break;
        case "tenant3":
          updateStateAndSubmit(setTenant3Signature, "tenant3_sign");
          break;
        case "manager":
          updateStateAndSubmit(setManagerSignature, "manager_sign");
          break;
      }
    } catch (error) {
      console.error("Signature Upload error:", error);
      toast.error(error?.response?.data?.message || "Signature upload failed");
    } finally {
      setLoading(false);
    }
  };

  const renderSignatureTrigger = (label, name, signatureData) => (<div className={`${styles.SignatureBlock}`}>
    {signatureData?.file_url ? (<img src={signatureData.file_url} alt="signature" className={`${styles.SignatureImage}`} />) : (<Button variant="outlined" onClick={() => { setCurrentSigner(name); setDrawerOpen(true); }}>Signature</Button>)}
    <p className={styles.SigTitle}>{label}</p>
    {name === "manager" ? <>
      <p className={styles.SigTitleTwo}>Authorized Agent <br />{moveOutCheckListInfo?.property_manager}</p>
    </> : <p className={styles.SigTitleTwo}>Tenant</p>}
  </div>);

  return (<div className={`${styles.CheckListFooterSec}`}>
    <div className={`${styles.CheckListFootCard}`}>
      <p className={`${styles.Title}`}>Move-out Inspection</p>
      {renderSignatureTrigger(`${moveOutCheckListInfo?.signed_by_name}`, "manager", managerSignature)}
      {moveOutCheckListInfo?.tenant1_name && renderSignatureTrigger(`${moveOutCheckListInfo.tenant1_name}`, "tenant1", tenant1Signature)}
      {moveOutCheckListInfo?.tenant2_name && renderSignatureTrigger(`${moveOutCheckListInfo.tenant2_name}`, "tenant2", tenant2Signature)}
      {moveOutCheckListInfo?.tenant3_name && renderSignatureTrigger(`${moveOutCheckListInfo.tenant3_name}`, "tenant3", tenant3Signature)}

      <p className={`${styles.SigDate}`}>Date of Move-out Inspection {formatDateUS(moveOutCheckListInfo?.inspection_date)}</p>
    </div>
    <Drawer
      anchor="bottom"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      className="ChecklistSignDrawer"
      ModalProps={{
        keepMounted: true, // improves performance on mobile
      }}
    >
      <div className={`${styles.DrawerContent}`}>
        <div className={`${styles.SignDrawerHead}`}>
          <p className={`${styles.DrawerSigTitle}`}>Sign as {currentSigner}</p>
          <button onClick={() => setDrawerOpen(false)} className={`${styles.CloseButton}`} aria-label="Close"><X /></button>
        </div>

        <SignatureCanvas
          penColor="black"
          canvasProps={{
            width: 330,
            height: 180,
            className: `${styles.SignatureCanvas}`,
          }}
          ref={signaturePadRef}
        />
        <div className={`${styles.ButtonAction}`}>
          <button onClick={() => signaturePadRef.current.clear()} className={`${styles.CancelPopupBU}`}>Clear</button>
          <button className={`${styles.SubmitPopupBU}`} variant="contained" onClick={() => {
            if (signaturePadRef.current.isEmpty()) {
              toast.error("Signature cannot be empty. Please provide a valid signature before submitting.");
              return;
            }
            const base64 = signaturePadRef.current.toDataURL();
            submitSignature(base64, currentSigner);
            setDrawerOpen(false);
          }}>Ok</button>
        </div>
      </div>
    </Drawer>
  </div>);
};
export default FormFooter;